// Locale-aware "time ago" formatting for card/list metadata (e.g. "2 days ago").
// Uses Intl.RelativeTimeFormat so en/ru/uz render in the active language with no
// per-unit i18n keys of our own.

interface Division {
  amount: number;
  unit: Intl.RelativeTimeFormatUnit;
}

const DIVISIONS: Division[] = [
  { amount: 60, unit: 'second' },
  { amount: 60, unit: 'minute' },
  { amount: 24, unit: 'hour' },
  { amount: 7, unit: 'day' },
  { amount: 4.34524, unit: 'week' },
  { amount: 12, unit: 'month' },
  { amount: Number.POSITIVE_INFINITY, unit: 'year' },
];

/** Returns '' for missing/invalid input, so callers can omit the segment entirely. */
export function formatRelativeTime(
  input: Date | string | number | null | undefined,
  locale = 'en',
): string {
  if (input == null) return '';
  const date = input instanceof Date ? input : new Date(input);
  const time = date.getTime();
  if (Number.isNaN(time)) return '';

  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto', style: 'short' });
  let duration = (time - Date.now()) / 1000; // seconds; negative for the past

  for (const division of DIVISIONS) {
    if (Math.abs(duration) < division.amount) {
      return rtf.format(Math.round(duration), division.unit);
    }
    duration /= division.amount;
  }
  return '';
}

export default formatRelativeTime;
